import request from './request';

export async function list(
  sortBy: string,
  sortOrder: string
): Promise<{ trainers: any[] }> {
  return request('GET', '/api/trainers', { sortBy, sortOrder });
}

export async function create(
  slug: string,
  title: string,
  titleEn: string,
  titleDe: string,
  name: string,
  nameEn: string,
  nameDe: string,
  description: string,
  descriptionEn: string,
  descriptionDe: string,
  shortDescription?: string,
  shortDescriptionEn?: string,
  shortDescriptionDe?: string,
  priority?: number,
  active?: boolean,
  isFeatured?: boolean
) {
  return request('POST', '/api/trainers', {
    active,
    isFeatured,
    slug,
    title,
    titleEn,
    titleDe,
    name,
    nameEn,
    nameDe,
    description,
    descriptionEn,
    descriptionDe,
    shortDescription,
    shortDescriptionEn,
    shortDescriptionDe,
    priority,
  });
}

export async function update(
  id: string,
  slug: string,
  title: string,
  titleEn: string,
  titleDe: string,
  name: string,
  nameEn: string,
  nameDe: string,
  description: string,
  descriptionEn: string,
  descriptionDe: string,
  shortDescription?: string,
  shortDescriptionEn?: string,
  shortDescriptionDe?: string,
  priority?: number,
  active?: boolean,
  isFeatured?: boolean
) {
  return request('POST', `/api/trainers/${id}`, {
    active,
    isFeatured,
    slug,
    title,
    titleEn,
    titleDe,
    name,
    nameEn,
    nameDe,
    description,
    descriptionEn,
    descriptionDe,
    shortDescription,
    shortDescriptionEn,
    shortDescriptionDe,
    priority,
  });
}

export async function setActive(id: string, active: boolean) {
  return request('POST', `/api/trainers/${id}`, { active });
}
export async function remove(id: string) {
  return request('DELETE', `/api/trainers/${id}`);
}
